/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliSubjectDto } from '../../models/amoxcalli-subject-dto';

export interface ApiSubjectsGet$Plain$Params {
  institutionId?: string;
}

export function apiSubjectsGet$Plain(http: HttpClient, rootUrl: string, params?: ApiSubjectsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliSubjectDto>>> {
  const rb = new RequestBuilder(rootUrl, apiSubjectsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('institutionId', params.institutionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliSubjectDto>>;
    })
  );
}

apiSubjectsGet$Plain.PATH = '/api/subjects';
